(function () { if (!LN.Core || !LN.Config) throw new Error("LN.Core || LN.Config missing"); })();

(function (Controller, Config, Helper, Service, Handler, Model, Message, Validation, View, $) {
    'use strict';

    Controller.validarTipoAsociacionClub = function () {
        Helper.updateToken();
        Service.ajaxPost('/Usuario/ObtenerDatosClub', false, function (res, status, xhr) {
            Handler.obtenerDatosClubHandler(res, status, xhr);
        }, null, {
            sentHeader: true
        });
    }

    Controller.buscarCredencial = function (credencial) {
        var crm = null;
        $(Model.Usuario.Credenciales).each(function () {
            if (this.nroTarjeta.replace(/-/gi, "") == credencial) crm = this.CrmId;
        })
        return crm;
    }

    Controller.asociarCrendecialValidaciones = function () {

        var credencial1 = $("#nro-credencial-1");
        var credencial2 = $("#nro-credencial-2");
        var credencial3 = $("#nro-credencial-3");
        var nroDocumento = $("#nro-documento");
        var tipoDocumentoValidacion = $("#tipo-documento option:selected").data('validator')

        var credencial = credencial1.val() + credencial2.val() + credencial3.val();
        var cantInputs = (nroDocumento.length > 0) ? 2 : 1;
        var cantInputsOk = 0;

        // Validación nro de credencial 
        var bStatusCred1 = Validation.Validators.credencialClub1.test(credencial1.val());
        var bStatusCred2 = Validation.Validators.credencialClub2.test(credencial2.val());
        var bStatusCred3 = Validation.Validators.credencialClub3.test(credencial3.val());
        Helper.changeStatus(credencial1, bStatusCred1);
        Helper.changeStatus(credencial2, bStatusCred2);
        Helper.changeStatus(credencial3, bStatusCred3);

        var credencialErrorMensaje = $("#credencial-error");
        if (!bStatusCred1 || !bStatusCred2 || !bStatusCred3) credencialErrorMensaje.html(Message.Credencial['INCORRECTA']);
        else credencialErrorMensaje.html('');

        if (bStatusCred1 && bStatusCred2 && bStatusCred3) {
            if (Model.Usuario.Credenciales.length == 1 && Model.Usuario.TipoAsociarCredencial == "1") { // Caso de asociación rápida (solo ingreso los dos últimos dígitos)
                cantInputsOk++;
                Model.Usuario.Credencial = Model.Usuario.Credenciales[0].nroTarjeta.replace(/-/gi, "").substr(0, 14) + credencial3.val();
            } else if (Validation.Validators.credencialClub.test(credencial)) {
                cantInputsOk++;
                Model.Usuario.Credencial = credencial;
            }
        }

        // Validación nro de documento 
        if (nroDocumento.length > 0) {
            if (Model.Cliente.numeroDocumento != "" && Validation.Validators.dni.test(Model.Cliente.numeroDocumento)) {
                cantInputsOk++;
                Helper.changeStatus(nroDocumento, true);
            } else {
              Helper.changeStatus(nroDocumento, false, Message.Credencial['DNI_INCOMPLETO'], Message.Analytics.Credencial['DNI_INCOMPLETO']);
            }
        }
        return cantInputs === cantInputsOk;
    }

    Controller.asociarCredencialCall = function (data) {
        Helper.updateToken();
        Service.asociarCredencial(data);
    }

    // Asociación directa . Tengo que autocompletar nro-crendencial-1 y nro-credencial-2, hacer que el usuario complete nro-credencial-3 (para caso 1 ) 
    // Para caso 3 tengo que completar la credencial completa . 
    // Tengo en memoria crm y nro-credencial . Voy al servicio con usuario-id y crm . 
    Controller.asociarCredencialCorto = function () {
        //$(".tarjeta-incorrecta").css("display", "none");
        if (Controller.asociarCrendecialValidaciones()) {
            if (Controller.buscarCredencial(Model.Usuario.Credencial) === null) {
                if (Model.Window.errorAttemps == 0) {
                    // Mostrar error
                    Model.Window.errorAttemps++;
                    var credencialErrorMensaje = $("#credencial-error");
                    credencialErrorMensaje.html(Message.Credencial['INCORRECTA_ATTEMP']);
                    //$(".tarjeta-incorrecta").css("display", "table");                    
                } else {
                    // Le erró al ingresar la credencial y redirige al ingreso de DNI - Credencial . 
                    Model.Usuario.TipoAsociarCredencial = "2";
                    View.asociarTarjeta();
                }

            } else {
                var data = {
                    crmId: Controller.buscarCredencial(Model.Usuario.Credencial),
                    estado: (Model.Usuario.Credenciales.length == 1) ? 1 : 2
                }
                Controller.asociarCredencialCall(data);
            }
        }
    }

    // Asociación largo . Tengo que completar nro-credencial y nro-documento . 
    Controller.asociarCredencialLargo = function () {

        // Si no tengo datos en el modelo, los cargo . 
        // Si lo tengo cargado en el modelo es porque entré por Flow D y tengo que asociar una credencial correspondiente al DNI cargado anteriormente .
        if (Model.Cliente.numeroDocumento == "" && Model.Cliente.tipoDocumento == "") {
            Model.Cliente.numeroDocumento = $("#nro-documento").val();
            Model.Cliente.tipoDocumento = $("#tipo-documento").val();
        }

        if (Controller.asociarCrendecialValidaciones()) {
            var data = {
                tipo_doc: Model.Cliente.tipoDocumento,
                nro_doc: Model.Cliente.numeroDocumento,
                nro_tarjeta: Model.Usuario.Credencial
            };
            Controller.asociarCredencialCall(data);
        }
    }

    Controller.finalizarAsociar = function () {
        Service.actualizarCookies(Controller.flowE);
    }

})(LN.Controller, LN.Config, LN.Helper, LN.Service, LN.Handler, LN.Model, LN.Message, LN.Validation, LN.View, jQuery);


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/credencialController.js